// extracted by mini-css-extract-plugin
export var disclaimer = "PostPage-module--disclaimer--caf44";